import FileTypes from "enums/fileTypes";
import FileStoragePermissionTypes from "enums/fileStoragePermissionTypes";

const fileStoragePermissions = [FileStoragePermissionTypes.Write, FileStoragePermissionTypes.Read];

const config = (endpointToGetSasLink: string, videoAssetId?: string) => {
  return {
    endpointToGetSasLink,
    sasRequest: {
      resourceType: FileTypes.Image,
      permissions: fileStoragePermissions,
      videoAssetId,
    },
  };
};

export default config;
